import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=51b155cf&"
import script from "./AvatarCard.vue?vue&type=script&lang=js&"
export * from "./AvatarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAvatar: require('/opt/buildhome/repo/components/base/Avatar.vue').default,BaseTitle: require('/opt/buildhome/repo/components/base/Title.vue').default,BaseBody: require('/opt/buildhome/repo/components/base/Body.vue').default})
